module.exports = "/assets/af2aafb65164686423db6a92cecd3378.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/T5.png
// module id = 2965
// module chunks = 0